import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  gap: 15px;
  flex-direction: column;
`;

export const Inputs = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  gap: 10px;
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;
